import { TemplateRef } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ILazyLoadContext } from '../shared/lazy-loader/lazy-loader.models';
import { IGroupedAndOrdered } from './ordering';


export enum SmartActionContextType {
    Dashboard = 'dashboard',
    Page = 'page',
}

export class BaseSmartActionStateModel {

    smartActionContext?: SmartActionContext;

    smartAction?: SmartActionContextItem;

    customView?: ILazyLoadContext<ConfirmationMetadata>;

}

export interface IActionContext {
    id: string;
    displayName: string;
    description: string;
}

export interface ISmartActionContext extends IGroupedAndOrdered {
    id: string;
    displayName: string;
    description: string;
    actions: SmartActionContextItem[];
    disabled?: boolean;
}

export class SmartActionContext implements ISmartActionContext {
    id: string;
    order?: number;
    group?: string;
    displayName: string;
    description: string;
    actions: SmartActionContextItem[];
    disabled?: boolean;



    get activeActions() {
        return this.actions ? this.actions.filter(actionItem => actionItem && !actionItem.separator) : [];
    }

    get disableSmartActions() {
        return this.activeActions && !(this.activeActions.length === 0) || this.activeActions[0].disabled === true;
    }

    constructor(input: Partial<ISmartActionContext>) {
        Object.assign(this, input);
    }

    addAction(action: SmartActionContextItem) {
        this.actions.push(action);
    }
    addActions(actions: SmartActionContextItem[]) {
        actions.forEach(action => this.addAction(action));
    }

    deleteActionById(actionId: string) {
        const index = this.actions.findIndex(action => action.id === actionId);
        if (index !== -1) {
            this.actions = this.actions.splice(index, 1);
        }
    }
    deleteActionsById(actionIds: string[]) {
        actionIds.forEach(actionId => this.deleteActionById(actionId));
    }
}

export class SmartActionContextItem {
    id?: string;
    order?: number;
    targetUI?: string;
    disabled?: boolean;
    separator?: boolean;
    displayName?: string;
    icon?: string;
    description?: string;
    actionMetadata?: any;
    template?: TemplateRef<any>;

    command?: (context: any) => Promise<any> | Promise<void>;

    target?: any;
    commandServiceToken?: string;
    commandName?: string;
    confirmation?: SmartActionContextItemConfirmation;
    children?: SmartActionContextItem[];

    constructor(input: Partial<SmartActionContextItem>) {
        Object.assign(this, input);
    }
}

export interface SmartActionContextItemConfirmation {
    id?: string;
    type?: ConfirmationType;
    options?: ISmartActionConfigOptions;
    title?: string;
    details?: string;
    okLabel?: string;
    closeLabel?: string;
}

export interface BaseSmartActionsStateModel {
    currentCustomView?: string;
}


export interface ConfirmationMetadata {
    target?: {};
    sourceAction?: SmartActionContextItem;
    context: { item: any };
    lazyComponentHandler: ILazyComponentHandler;
    command?: (context: any) => Promise<any>;
}

export interface ISmartActionMetadata {
    context: any;
    lazyComponentHandler: ILazyComponentHandler;
    sourceAction: SmartActionContextItem;
    id: string;
    options: any;
}



export interface ILazyComponentHandler {
    lazyComponentHandlerId?: string;
    currentCustomViewMetadata?: any;
    customViewSync: string;
    setCurrentCustomView(viewId: string, metadata?: any);
}


export interface ISmartActionStandaloneMetadata{
    actionItem: any,
}

// tslint:disable-next-line: no-empty-interface
export interface ISmartActionConfigOptions {
}

export declare type ConfirmationType = 'custom' | 'dialog' | 'popup';
